import { render } from "./AddAssessmentCategory.vue?vue&type=template&id=2935aa70&scoped=true"
import script from "./AddAssessmentCategory.vue?vue&type=script&lang=js"
export * from "./AddAssessmentCategory.vue?vue&type=script&lang=js"

import "./AddAssessmentCategory.vue?vue&type=style&index=0&id=2935aa70&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_typescript@5.4.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2935aa70"]])

export default __exports__